function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "7935ec95c421cee6d86eb22ecd125aef"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.22498 22V7.1559H0.291643V21.9999H5.22498V22ZM2.75883 5.12994C4.47864 5.12994 5.54995 3.98913 5.54995 2.5647C5.51743 1.1086 4.47864 0 2.79108 0C1.10324 4.50414e-05 0 1.10865 0 2.56474C0 3.98918 1.07072 5.12999 2.72635 5.12999L2.75883 5.12994ZM7.95538 22C7.95538 22 8.02011 8.54867 7.95538 7.15595H12.8895V9.30865H12.8567C13.5055 8.29567 14.6743 6.80737 17.3357 6.80737C20.5825 6.80737 23.0161 8.92895 23.0161 13.4885V22H18.0828V14.0588C18.0828 12.0635 17.369 10.7019 15.5831 10.7019C14.2205 10.7019 13.4084 11.6198 13.0517 12.5071C12.9212 12.823 12.8895 13.2666 12.8895 13.7102V22H7.95538Z",
  fill: "#0072B1"
}));

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.eca7a1a306ad98f064655f6098275821.svg";
export { ForwardRef as ReactComponent };